import React from 'react';
import CardCommon from '@/pages/opinion/components/CardCommon';
import ChannelsLanguageChart from '../../../Performance/components/ChannelsLanguageChart';
import { useDrilldownParams } from '@op/hooks/useDrilldownParams';
import { useHistory, useIntl } from 'umi';
import { isStatsDetail } from '../../utils';

export default function TimelineOfMentionsCharts({
  data,
  filter,
  loading,
  dataType,
  lang,
  isVersion,
  handleStatsDetailOnClick,
  regionType,
}: any) {
  const statsDetailType = 'stats-timeline-of-sentiment';
  const history = useHistory();
  const { goPage } = useDrilldownParams();

  const { formatMessage } = useIntl();
  const isDetail = isStatsDetail(history);
  return (
    <CardCommon
      title={formatMessage({ id: 'Timeline of Sentiment' })}
      bodyStyle={{ height: 375 }}
      hasTitleArrow={!isDetail}
      handleTitleOnClick={() => {
        if (isDetail) {
          return;
        }
        goPage({
          path: '/opinion/Stats/Detail',
          filter: {
            filter,
            statsDetailType,
            statsDetailChartsData: {
              data,
              dataType,
              isVersion,
              regionType,
            },
          },
        });
      }}
    >
      <ChannelsLanguageChart
        dataType={dataType}
        data={data}
        filter={filter}
        isVersion={isVersion}
        showTitle={false}
        loading={loading}
        lang={lang}
        height={308}
        type="sentiment-line"
        statsDetailType={statsDetailType}
        handleStatsDetailOnClick={handleStatsDetailOnClick}
        regionType={regionType}
      ></ChannelsLanguageChart>
    </CardCommon>
  );
}
